import * as React from 'react';

export interface ILabelProps {
  label?: React.ReactNode | string;
  labelIcon?: React.ReactNode;
  children?: React.ReactNode;
  htmlFor?: string;
  className?: string;
}

export default function Label(props: ILabelProps) {
  const { labelIcon, label, htmlFor, className } = props;
  return (
    <label
      htmlFor={htmlFor}
      className={`inline text-gray-700 font-medium text-sm ${className}`}
    >
      {label && (
        <div className="inline-flex items-center py-2 w-full">
          {labelIcon && <span className="pr-2">{labelIcon}</span>}

          <span className="w-full whitespace-pre-line">{label}</span>
        </div>
      )}

      {props.children}
    </label>
  );
}
